/** Emit code as a JS string that a one-line loader assigns to script.textContent, so the HTML
 * raw-text rules for `<!--` and `</script` never apply to the payload. Needs script-src
 * 'unsafe-inline'.
 */
export const inlineScript = (code: string): string => {
  const serialized = JSON.stringify(code).replaceAll('<', '\\u003c')
  return `(()=>{const script=document.createElement('script');script.textContent=${serialized};document.head.append(script)})()`
}
